/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceQuoteLineResource
 */
export interface FixedPriceQuoteLineResource {
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteLineResource
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteLineResource
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteLineResource
     */
    unitPriceExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteLineResource
     */
    totalPriceExcludingTaxes?: number;
}

/**
 * Check if a given object implements the FixedPriceQuoteLineResource interface.
 */
export function instanceOfFixedPriceQuoteLineResource(value: object): value is FixedPriceQuoteLineResource {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    return true;
}

export function FixedPriceQuoteLineResourceFromJSON(json: any): FixedPriceQuoteLineResource {
    return FixedPriceQuoteLineResourceFromJSONTyped(json, false);
}

export function FixedPriceQuoteLineResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteLineResource {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
        'totalPriceExcludingTaxes': json['totalPriceExcludingTaxes'] == null ? undefined : json['totalPriceExcludingTaxes'],
    };
}

export function FixedPriceQuoteLineResourceToJSON(value?: FixedPriceQuoteLineResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
        'totalPriceExcludingTaxes': value['totalPriceExcludingTaxes'],
    };
}

